import { connect } from 'react-redux'
import { UploadModal } from './UploadModal'
import { AppStateType } from '../../reducers'
import { selectRelatedEditions } from '../../selectors/pack'
import { extractFileName } from '../../services/file'

const mapStateToProps = (state: AppStateType, ownProps) => ({
  // TODO: investigate if we can extract relatedEditions in file service, since it is used only there @Andrew
  relatedEditions: selectRelatedEditions(extractFileName(ownProps.file))(state),
})

export default connect(mapStateToProps)(UploadModal)
